import React, { useEffect, useState, useRef } from "react";
import Dashboard from "../../Components/Dashboard";
import { store } from "../../store";
import useStyle from "../Ebook/style";
import Denied from "../../Components/Denied";
import { apiLabs, apiTelesales } from "../../Services/api";
import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

function Telesales(props) {
  const {
    location: { idPage },
  } = props;

  const [auth, setAuth] = useState(null);

  const [data, setData] = useState({ file: "" });
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const style = useStyle();

  async function verifyAuth() {
    const { profile } = store.getState().user;
    const res = await apiLabs.post("valid_key", {
      id: profile.id,
      menu_id: idPage,
    });
    if (res.data.message === "User not authorized") {
      return setAuth("denied");
    }
    if (res.data.message === "User authorized") {
      return setAuth("authorized");
    }
  }

  const uploadSpreadsheet = async (e) => {
    const file = e.target.files[0] ? e.target.files[0] : [];
    if (file.length !== 0) {
      if (!file.name.includes("xlsx")) {
        e.target.value = "";
        setData({
          file: "",
        });
        toast.error("Formato inválido, por favor selecione um formato válido");
        return;
      }
    }

    file.arrayBuffer().then((res) => {
      const data = new Uint8Array(res);

      const workbook = XLSX.read(data, { type: "array" });
      const first_sheet_name = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[first_sheet_name];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        defval: null,
      });

      let fileName;

      if (file) {
        fileName = file?.name.substring(0, file?.name?.indexOf("."));
      }

      const new_worksheet = XLSX.utils.json_to_sheet(jsonData);

      const dataFileCSV = XLSX.utils.sheet_to_csv(new_worksheet, {
        raw: false,
        defval: null,
      });

      const blob = new Blob([dataFileCSV], { type: "text/csv;charset=utf-8;" });

      const fileBlob = new File([blob], `${fileName}.csv`, {
        type: "text/csv;charset=utf-8;",
        lastModified: new Date(),
      });

      setData({
        ...data,
        file: fileBlob,
      });
    });
  };
  const handleSubmit = async (e) => {
    setLoading(true)
    e.preventDefault();
    let obj = new FormData();

    obj.append("file", data.file);

    if(!data.file) {
      toast.error("Preencha o campo Planilha Televendas com uma planilha válida");
      setLoading(false)
      return
    }

    try {
      await apiTelesales.post("/bluesoft", obj);

      toast.success("Planilha enviada com sucesso, aguarde aproximadamente 10 minutos de processamento");
     setData({ file: "" });
     formRef.current.reset();

     setTimeout(() => {
       window.location.reload();
       setLoading(false)
     }, 3000)

    } catch (error) {
      console.log(error)
      if(error.response.status === 200) {
        toast.success("Planilha enviada com sucesso, aguarde aproximadamente 10 minutos de processamento");
        setData({ file: "" });
        formRef.current.reset();
        return
      }

      setLoading(false)
      toast.error(
        "Error ao enviar planilha, tente novamente"
      );

      return
    }
  };

  useEffect(() => {
    verifyAuth();
  }, []);

  return (
    <>
      <Dashboard title="Televendas">
        {auth === "denied" && <Denied />}
        {auth === "authorized" && (
          <Container className={`${style.fullWidth} ${style.containerEbook}`}>
            <form
              onSubmit={(e) => handleSubmit(e)}
              encType="multipart/form-data"
              style={{ maxWidth: 900, width: "100%", padding: 25 }}
              ref={formRef}
            >
              <Grid className={style.ebookForm}>
                <Box className={`${style.formInput}`}>
                  <Typography className={style.title}>
                    Planilhas Televendas
                  </Typography>
                  <TextField
                    accept=".xlsx"
                    id="file"
                    label="Planilha Televendas"
                    placeholder="Planilha Televendas"
                    onChange={(e) => uploadSpreadsheet(e, 0)}
                    margin="normal"
                    type="file"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    name="file"
                  />
                </Box>
              </Grid>
              <Grid className={style.button}>
                <Button type="submit" disabled={loading}>Salvar</Button>
              </Grid>
            </form>
          </Container>
        )}
      </Dashboard>
    </>
  );
}

export default Telesales;
